import { Components } from '@mui/material'

export const MuiButton: Components['MuiButton'] = {
  variants: [
    {
      props: { size: 'medium' },
      style: {
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '8px',
        paddingBottom: '8px',
      },
    },
  ],
}
